import { MouseEvent } from "react";
import { Asset, DisplayTypes } from "lib/types";

export const isVideo = (asset: Asset<any>): boolean => (
  asset.data?.content_type?.startsWith('video/') && asset.data?.content_type === 'video/mp4'
);

export const isImage = (asset: Asset<any>): boolean => {
  const content_type = asset.data?.content_type?.split('/')[0];
  return content_type === DisplayTypes.IMAGE;
}

export const openLink = (e: MouseEvent, asset: Asset<any>): void => {
  e.stopPropagation();
  window.open(asset.data.url);
}
